import React from 'react';

const SvgTikTok = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.5 0H2.5C1.4 0 .5.9.5 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm-1.67 7.05c-.08.01-.16.01-.24.01-.95 0-1.8-.41-2.39-1.06v3.64a3.07 3.07 0 0 1-3.07 3.07 3.07 3.07 0 0 1-3.07-3.07 3.07 3.07 0 0 1 3.07-3.07c.09 0 .18.01.27.02v1.52c-.09-.01-.18-.02-.27-.02a1.55 1.55 0 0 0-1.55 1.55c0 .86.7 1.55 1.55 1.55.86 0 1.6-.67 1.6-1.53l.02-6.32h1.46c.14 1.17 1.05 2.11 2.22 2.28v1.43h-.6Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTikTok;
